import { Link } from "react-router-dom";
import { slugify } from "../data/books";
import { hasChapter, getPopulatedChapters } from "../data/chapters";

export default function BookList({ title, books, testId }) {
  return (
    <section data-testid={testId} className="fade-in">
      <h2
        className="text-center"
        style={{
          fontSize: "clamp(1.5rem, 2.4vw, 2rem)",
          letterSpacing: "0.18em",
          margin: "0 0 0.4rem 0",
        }}
      >
        {title}
      </h2>
      <div className="ornament mb-8" aria-hidden>
        <span>&#10086;</span>
      </div>

      <ul className="space-y-7">
        {books.map((book) => {
          const slug = slugify(book.name.replace(/^st\.?\s+/i, ""));
          const populated = getPopulatedChapters(slug);
          return (
            <li key={book.name} data-testid={`book-${slug}`}>
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-2">
                <h3
                  style={{
                    fontSize: "1.35rem",
                    margin: 0,
                    color: "var(--ink)",
                    letterSpacing: "0.04em",
                  }}
                >
                  {book.name}
                </h3>
                <Link
                  to={`/book/${slug}/introduction`}
                  data-testid={`book-intro-${slug}`}
                  style={{
                    fontStyle: "italic",
                    fontSize: "1rem",
                    color: "var(--oxblood)",
                  }}
                >
                  Introduction
                </Link>
                <span
                  style={{
                    color: "var(--ink-muted)",
                    fontSize: "0.95rem",
                  }}
                >
                  &middot; {book.chapters}{" "}
                  {book.chapters === 1 ? "chapter" : "chapters"}
                  {populated.length > 0 && (
                    <em
                      style={{
                        color: "var(--gold)",
                        fontStyle: "italic",
                        marginLeft: "0.5rem",
                      }}
                    >
                      &middot; {populated.length} transcribed
                    </em>
                  )}
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {Array.from({ length: book.chapters }, (_, i) => i + 1).map(
                  (n) => {
                    const isSample = hasChapter(slug, n);
                    return (
                      <Link
                        key={n}
                        to={`/book/${slug}/chapter/${n}`}
                        className={`chapter-link${isSample ? " sample" : ""}`}
                        data-testid={`chapter-${slug}-${n}`}
                        title={
                          isSample
                            ? `Read ${book.name} ${n} (transcribed)`
                            : `${book.name} ${n}`
                        }
                      >
                        {n}
                      </Link>
                    );
                  },
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
